import React, { Fragment } from "react";
import { connect, useSelector } from "react-redux";
import cx from "classnames";

import { useResizeDetector } from "react-resize-detector";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../hooks/use-mobile";
import AppHeader from "./admin/header/AdminHeader";
import AdminSidebar from "./admin/sidebar/AdminSidebar";
import ThemeOptions from "./admin/ThemeOptions";
import "./Layout.css";

export default function AdminLayout() {
  const [isMobile] = useIsMobile();
  const { pathname } = useLocation();
  const isLoginPage = pathname === "/login";


  // const [sidebarOpen, setSidebarOpen] = useState(false);
  // const toggleSidebar = () => setSidebarOpen((v) => !v);

  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = useSelector((state: any) => state.ThemeOptions);

  const { width, ref } = useResizeDetector();
  const w = width ?? 1200;

  return isLoginPage ? (
    <div className={`flex ${isMobile ? "h-screen" : "h-fit"}`}>
      {/* {expired && !isLoginPage && (
        <NotifyDialog
          title="Phiên đăng nhập hết hạn"
          message="Vui lòng đăng nhập lại để tiếp tục"
          buttonText="Quay về đăng nhập"
          onButtonClick={() => navigate("/config/login")}
        />
      )} */}

      {/* {!isLoginPage && (
        <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      )} */}

      <div className="min-h-screen flex-1 flex flex-col">
        {/* {!isLoginPage && <AppHeader />} */}
        {/* {!isLoginPage && <AdminNavMenu />} */}

        <main className="relative h-full">
          <Outlet />
        </main>
      </div>
    </div>
  ) : (
    <Fragment>
      <ThemeOptions />
      <div ref={ref}>
        <div
          className={cx(
            `app-container app-theme-${colorScheme}`,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar || w < 992 },
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": (enableClosedSidebar && !isMobile) || (w < 992 && !isMobile) },
            { "closed-sidebar-mobile": w < 992 && !isMobile },
            { "sidebar-mobile-open": enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}
        >
          {/* {expired && !isLoginPage && (
            <NotifyDialog
              title="Phiên đăng nhập hết hạn"
              message="Vui lòng đăng nhập lại để tiếp tục"
              buttonText="Quay về đăng nhập"
              onButtonClick={() => navigate("/config/login")}
            />
          )} */}

          {!isLoginPage && <AppHeader />}

          <div className="app-main">
            {!isLoginPage && <AdminSidebar />}

            <div className="app-main__outer">
              <div className="app-main__inner" style={{padding: 0}}>
                <Outlet />
              </div>
              {/* <AppFooter /> */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
